module.exports = __webpack_public_path__ + "media/assets/success-57fda9d2847e35d1fd2e45dcf6bb9fb1eadcd27a3ffe9a439b398c025c2ca758.svg";